import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { CMSFaq } from '@/api/cms/restrictions';
import { FAQByGroup } from '@/modules/restrictions/components/FAQByGroup';
import { ScFaq } from './styled';

interface IFaqProps {
  namespace: string;
  sections?: CMSFaq[] | null;
  bgImage?: string;
}

export const Faq: FC<IFaqProps> = ({ namespace, sections, bgImage }) => {
  const { t } = useTranslation(namespace);

  if (!sections?.length) return null;

  return (
    <ScFaq $bgImage={bgImage}>
      <FAQByGroup sections={sections} title={t('faq.title')} withTitle />
    </ScFaq>
  );
};
